<template>
  <div class="attached_files">
    <div class="mb-1">
      <label class="d-block font-weight-bolder pb-0">Đính kèm</label>
    </div>
    <div class="file-upload row">
      <file-upload
        ref="uploadAttachFileRef"
        v-model="fileItems"
        class="col-md-6"
        button-class="btn-sm"
        :auto-upload="true"
        :show-sync-dalet="false"
        :sync-dalet="false"
        :remove-file-after-success="false"
        :close-modal-after-all-success="false"
        input-id="input-upload-attach-file"
        @click-file="onPreview"
      >
        <template #file-list="{ fileDataList }">
          <div
            v-if="fileDataList.length > 0"
            class="boxmedia mt-1"
          >
            <table class="table table-striped">
              <tbody>
                <tr
                  v-for="(item, index) in fileDataList"
                  :key="index"
                >
                  <td
                    width="250"
                    @click="downloadfile(item)"
                  >
                    <p
                      class="mb-0 lineText"
                      @click="onPreview(item)"
                    >
                      <strong>{{ item.filename_original }}</strong>
                    </p>
                    <p
                      v-if="item.error"
                      class="text-danger fs_9 font-weight mb-0"
                    >{{ item.error }}</p>
                    <div v-else>
                      <p
                        v-if="item.success || item.uploaded"
                        class="size fs_9 font-weight mb-0"
                      >
                        <span>{{ $refs.uploadAttachFileRef.formatFileSize(item.size) }}</span>
                      </p>
                      <p
                        v-else
                        class="mb-0 size"
                      >{{ $refs.uploadAttachFileRef.formatFileSize(item.progress * item.size / 100) }}/{{ $refs.uploadAttachFileRef.formatFileSize(item.size) }}</p>
                      <b-progress
                        v-if="!item.success && !item.uploaded"
                        max="100"
                        show-value
                        variant="success"
                        class="progress-bar-success"
                      >
                        <b-progress-bar
                          :value="item.progress"
                          :label="`${item.progress}%`"
                          variant="success"
                        />
                      </b-progress>
                    </div>
                  </td>
                  <td
                    class="text-right"
                    width="90"
                  >
                    <b-button
                      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                      variant="outline-danger"
                      class="btn-icon btn-sm rounded-circle ml-1"
                      @click.prevent="confirmDeleteFileContent(item)"
                    >
                      <span>
                        <feather-icon icon="XIcon" />
                      </span>
                    </b-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
      </file-upload>
    </div>
  </div>
</template>

<script>
import {
  computed,
} from '@vue/composition-api';
import Ripple from 'vue-ripple-directive'
import { showToast } from '@/@core/utils/utils';
import {
  BProgress, BProgressBar, BButton,
} from 'bootstrap-vue'
import axios from 'axios';
import FileUpload from '../files/components/FileUpload.vue';

export default {
  components: {
    FileUpload,
    BButton,
    BProgress,
    BProgressBar,
  },
  directives: {
    Ripple,
  },
  props: {
    topClass: {
      type: String,
      default: '',
    },
    attachedFiles: {
      type: Array,
      default: null,
    },

  },
  data() {
    return {

    }
  },
  computed: {
  },
  setup(props, context) {
    const fileItems = computed({
      get() {
        console.log('props.attachedFiles', props.attachedFiles);
        return props.attachedFiles
      },
      set(val) {
        context.emit('update-attached-files', val)
      },
    });

    return {
      fileItems,

    }
  },
  methods: {
    onUpdateContentEditor(item) {
      this.$emit('update-content-editor', item)
    },
    confirmDeleteFileContent(file) {
      this.$swal({
        title: 'Bạn chắc muốn xóa?',
        text: 'Xóa dữ liệu sẽ ảnh hưởng đến các chức năng khác trong hệ thống!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Có',
        cancelButtonText: 'Không',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          console.log(this.$refs)
          this.$refs.uploadAttachFileRef.deleteUploadFile(file)
        }
      })
    },
    onPreview(item) {
      if (item.success && item.uploaded) {
        this.$emit('preview', item)
      } else {
        showToast('File chưa upload')
      }
    },
    downloadfile(item) {
      axios
        .get(item.full_path ?? item.file_local, {
          headers: {
            Accept: item.mimetype,
          },
          responseType: 'blob',
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: item.mimetype })
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = item.name;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch((error) => {
          console.log(JSON.stringify(error))
        })
    },

  },
}
</script>

<style lang="scss" scoped></style>
